import * as React from 'react';

/**
 * Provides localized labels for internal usecases in common-ui components.
 */
const LocalizationProvider = ({ children, dictionary }) => {
    return React.createElement(LocalizationContext.Provider, { value: { dictionary } }, children);
};
const LocalizationContext = React.createContext({
    dictionary: {
        close: 'Close',
        remove: 'Remove',
        sortAscending: 'Sort ascending',
        sortDescending: 'Sort descending',
        clear: 'Clear',
        progressLine: 'Progress line',
        search: 'Search',
        'search.noResults': 'No results found',
        'search.checkAndTryAgain': 'Please check your search keyword and try again.',
        'table.dragHandleLabel': 'Drag and drop to reorder columns.',
        'table.selectRow': 'Select',
        'table.selectAllRows': 'Select all',
        'tree.expandItem': 'Expand',
        'multiSelect.create': 'Create',
        'multiSelect.select': 'Select',
        'timePicker.time': 'Time',
        'timePicker.minutes': 'Minutes',
        'timePicker.hours': 'Hours',
        'timePicker.addMinutes': 'Add minutes',
        'timePicker.subMinutes': 'Subtract minutes',
        'timePicker.addHours': 'Add Hours',
        'timePicker.subHours': 'Subtract hours',
        'timePicker.apply': 'Apply',
        'timePicker.yourSelection': 'Your selection',
    },
});
/**
 * Use a localized label.
 */
const useLocalization = (key) => {
    const { dictionary } = React.useContext(LocalizationContext);
    return dictionary[key];
};

export { LocalizationContext, LocalizationProvider, useLocalization };
